import React from "react";
import { AlertTriangle } from "lucide-react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info);
  }

  render() {
    if (this.state.hasError) {
      // Same default as LanguageContext: someone who has not chosen a language
      // yet is reading an English page, and the crash screen should match it.
      const lang = localStorage.getItem("mealpill_lang") || "en";
      const M = {
        uk: { title: "Щось пішло не так", sub: "Спробуйте оновити сторінку", btn: "Оновити" },
        en: { title: "Something went wrong", sub: "Try refreshing the page", btn: "Refresh" },
        ru: { title: "Что-то пошло не так", sub: "Попробуйте обновить страницу", btn: "Обновить" },
      };
      const m = M[lang] || M.uk;
      return (
        <div className="min-h-screen bg-[#FAFAF8] flex flex-col items-center justify-center px-6 text-center">
          <div className="w-16 h-16 rounded-2xl bg-[#BC4749]/10 flex items-center justify-center mb-4">
            <AlertTriangle className="w-8 h-8 text-[#BC4749]" strokeWidth={1.5} />
          </div>
          <h2 className="font-heading text-xl text-[#3D4035] mb-2">{m.title}</h2>
          <p className="font-body text-sm text-[#A5A58D] mb-6">{m.sub}</p>
          <button
            onClick={() => { this.setState({ hasError: false, error: null }); window.location.reload(); }}
            className="px-6 py-3 bg-[#7B9E7F] text-white rounded-full font-body font-semibold text-sm hover:bg-[#6B8E6F] transition-colors"
          >
            {m.btn}
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
